import { Link } from 'react-router-dom';
import type { AuthUser } from '../../hooks/useAuth';
import { ThemeToggle } from '../ui/ThemeToggle';
import { useTheme } from '../../hooks/useTheme';
import { Bell } from 'lucide-react';

// Color e inicial del avatar por rol
const AVATAR_CONFIG: Record<string, { bg: string; label: string }> = {
  broker:           { bg: 'bg-broker',   label: 'C' },
  carrier:          { bg: 'bg-carrier',  label: 'T' },
  service_provider: { bg: 'bg-provider', label: 'P' },
};

interface AppHeaderProps {
  user: AuthUser;
  notificationCount?: number;
}

export function AppHeader({ user, notificationCount = 0 }: AppHeaderProps) {
  const { isDark } = useTheme();
  const avatar = AVATAR_CONFIG[user.role];
  // Iniciales del nombre (máx 2 caracteres)
  const initials = user.name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase();

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-white dark:bg-dark-card border-b border-gray-200 dark:border-dark-border">
      <div className="flex items-center justify-between px-4 h-14 max-w-lg mx-auto">

        {/* Logo */}
        <Link to="/dashboard">
          <img
            src={isDark ? '/logo_cargalo-dark.png' : '/logo_cargalo.png'}
            alt="Cárgalo"
            className="h-7 w-auto"
          />
        </Link>

        {/* Acciones derecha */}
        <div className="flex items-center gap-3">

          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Notificaciones */}
          <Link
            to="/notifications"
            className="relative text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-dark-text transition-colors"
            aria-label="Notificaciones"
          >
            <Bell className="w-5 h-5" strokeWidth={2} />
            {notificationCount > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[16px] h-4 bg-danger text-white text-[9px] font-bold rounded-full flex items-center justify-center px-1 border-2 border-white dark:border-dark-card">
                {notificationCount > 99 ? '99+' : notificationCount}
              </span>
            )}
          </Link>

          {/* Avatar */}
          <Link
            to="/profile"
            aria-label="Perfil"
          >
            <div className={`w-8 h-8 rounded-full ${avatar.bg} flex items-center justify-center text-white text-xs font-bold`}>
              {initials || avatar.label}
            </div>
          </Link>

        </div>
      </div>
    </header>
  );
}
